import { render } from "./Navbar.vue?vue&type=template&id=f9d63b3a"
import script from "./Navbar.vue?vue&type=script&scoped=true&lang=js"
export * from "./Navbar.vue?vue&type=script&scoped=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=f9d63b3a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\german\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__